import { Link } from 'react-router-dom'
import { Tag } from 'lucide-react'

interface SectionHeaderProps {
  title: string
  viewAllTo?: string
  icon?: 'tag' | 'none'
}

export function SectionHeader({ title, viewAllTo, icon = 'tag' }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2.5">
        {icon === 'tag' && <Tag className="w-5 h-5 text-brand-600" />}
        <h2 className="text-xl font-bold text-text">{title}</h2>
      </div>
      {viewAllTo && (
        <Link to={viewAllTo} className="text-sm text-brand-600 hover:underline font-medium">
          Xem tất cả
        </Link>
      )}
    </div>
  )
}
